import { DataGrid } from "devextreme-react";
import { Paging, Scrolling, SearchPanel, Column, LoadPanel } from "devextreme-react/data-grid";
import { userAssignmentClientApi } from "../../api-client-nswag/taxportal-client-runtime";
import { dataGridConfig, defaultPageSize } from "../../constants";
import { useEffect, useRef, useState } from "react";
import { convertUTCTimeToLocal } from "../../util/Utils";
import { isEmpty, isNull } from "lodash";
import { useSnackbar, SnackbarMessage } from "../../hooks";
import { usersInfo } from "./UserAssignments";
import { UserAssignmentHistoryResponse } from "../../api-client-nswag/userassignment-client";
import { Pagination } from "@mui/material";

type DatagridRefType = DataGrid;

export const UserHistory = (props: any) => {
    const dataGridRef = useRef<DatagridRefType>(null);
    const [pageNumber, setpageNumber] = useState(1);
    const [data, setData] = useState<usersInfo>({ pending: true, data: [], totalCount: 0 })
    const [searchTerm, setSearchTerm] = useState<string | null | undefined>(null);
    const { showSnackbar, showSuccessSnackbar } = useSnackbar();

    const fetchData = async () => {
        setData(prev => ({ ...prev, pending: true, data: [] }));
        try {
            const startIndex = pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
            const userAssignmentData: UserAssignmentHistoryResponse = await userAssignmentClientApi.userAssignment_UserAssignmentHistory(props.siteId, null, props.userId, startIndex, defaultPageSize);
            setData({ pending: false, data: userAssignmentData?.data?.userAssignmentHistory, totalCount: userAssignmentData?.data?.totalCount })
        }
        catch (error) {
            setData(prev => ({ ...prev, pending: false }));
            showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
        }
    }

    const fetchDataBySearch = async () => {
        setData(prev => ({ ...prev, pending: true }));
        try {
            const userAssignmentData: UserAssignmentHistoryResponse = await userAssignmentClientApi.userAssignment_UserAssignmentHistory(props.siteId, searchTerm, props.userId);
            setData({ pending: false, data: userAssignmentData?.data?.userAssignmentHistory, totalCount: data.totalCount })
        }
        catch (error) {
            setData(prev => ({ ...prev, pending: false }));
            showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
        }
    }

    useEffect(() => {
        if (!isNull(searchTerm) && !isEmpty(searchTerm)) {
            fetchDataBySearch();
        }
    }, [props.appName, searchTerm]);

    useEffect(() => {
        if (searchTerm === null || searchTerm?.length === 0) {
            fetchData()
        }
    }, [pageNumber, props.appName, searchTerm]);


    const cellRenderForDate = (e: any) => {
        return <div>{convertUTCTimeToLocal(e.data.lastActivityDate)}</div>;
    };


    return (
        <div>
            <div
                style={{
                    margin: "0 0 10px 0",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            ></div>

            <DataGrid
                ref={dataGridRef}
                {...dataGridConfig}
                showBorders={true}
                height={`calc(100vh - 260px)`}
                dataSource={data.data}
                noDataText={data.pending ? "Loading..." : "No Data"}
            >
                <Paging defaultPageSize={5} />
                <LoadPanel enabled={false} />
                <Scrolling columnRenderingMode="virtual" />
                <SearchPanel placeholder={"Global Search..."}
                    onTextChange={(e) => {
                        setSearchTerm(e);
                    }} visible />
                <Column
                    alignment="left"
                    dataField="roleName"
                    caption={"Role"}
                ></Column>
                <Column
                    alignment="left"
                    dataField="lastActivity"
                    caption={"Activity"}
                ></Column>
                <Column
                    alignment="left"
                    dataField="lastActivityDate"
                    cellRender={cellRenderForDate}
                    caption={"Date"}
                ></Column>
            </DataGrid>
           {isEmpty(searchTerm) && data?.totalCount && data?.totalCount > defaultPageSize && <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: "5px 0 0 0",
                }}
            >
                <Pagination
                    onChange={(e: any, pageNumber: any) => {
                        setpageNumber(pageNumber);
                    }}
                    count={Math.ceil((data.totalCount as number) / defaultPageSize)}
                    variant="outlined"
                    shape="rounded"
                />
            </div>}
        </div>
    );
};